/**
 * SafeJsonLd - Centralized JSON-LD schema injection component.
 * Encapsulates dangerouslySetInnerHTML in one auditable location.
 * JSON.stringify() already escapes all special characters, making this safe.
 */
const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);

export default JsonLd;
